import { render, staticRenderFns } from "./DisplaySetting.vue?vue&type=template&id=47ad55ab&scoped=true&"
import script from "./DisplaySetting.vue?vue&type=script&lang=js&"
export * from "./DisplaySetting.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySetting.vue?vue&type=style&index=0&id=47ad55ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad55ab",
  null
  
)

export default component.exports